import { Dialog, DialogProps } from "../core/components/dialog.js";
import { Config } from "../core/config/config.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { AppHelper } from "../appHelper.js";
import { CommonApp, Entity, Metadata } from "../core/components/commonApp.js";
import { Grid } from "../core/components/grid.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { MultipleRadioButtons } from "../core/components/multipleRadioButtons.js";
import { Button } from "../core/components/button.js";
import { TextBox } from "../core/components/textBox.js";
import { RegionSizeRule } from "../core/components/region.js";
import React from "react";
import ReactDOM from "react-dom";

export const OpenResourcePlanningDeletionDialog = async (entity: ResourcePlanningDeletionEntity, assignmentDeleted: (multiple: boolean) => void) => {

    let deletePreview = await HTTPService.get<JsonResultClass<DeletingExecutionAssignmentPreviewEntity>>(
        'ResourcePlanning/GetDeletingExecutionAssignmentPreview?projNr=' + encodeURIComponent(entity.ProjNr) + '&pIndex=' + entity.PIndex + '&lockCycle=true');

    if (deletePreview.Code == 0 && deletePreview.Data.Preview.TaskExecutionInfo != null) {
        let baseEntity = Helper.createEmptyEntity();
        const props: ResourcePlanningDeletingExecutionAssignmentProps = {
            entity: { ...baseEntity, ...entity, ...deletePreview.Data },
            context: {},
            title: "",
            assignmentDeleted: assignmentDeleted,
            metadata: createMetadata()
        }

        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, () => {
        });

        sheet.show(() => {
            sheet.mountContent(ResourcePlanningDeletingExecutionAssignmentApp, props);
        });
    }
    else {
        const targetElement = $("<div>");
        const root = ReactDOM["createRoot"](targetElement[0]);
        let title = Helper.getTranslation("Einsatz.EinsatzWirklickLöschen");
        const props: any = {
            onOk: () => {
                HTTPService.post<JsonResultClass>(`ResourcePlanning/DeleteAssignment?projNr=${encodeURIComponent(entity.ProjNr)}&pIndex=${entity.PIndex}`)
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            assignmentDeleted(false);
                        } else {
                            NotificationHelper.showErrorResult(result);
                        }
                    });
            },
            onCancel: () => {
                root.unmount();
            },
            entity: entity,
            title: title
        }
        $("body").append(targetElement);
        root.render(<ResourcePlanningDeletionDialog {...props} />);
    }
}

const createMetadata = (): Metadata => {
    const einsatzFields = ([
        {
            visible: true,
            componentName: "renderDisplayInfo()",
            model: "",
            type: "dynamic",
            name: "",
            labelAndControlCombined: true
        },
        {
            visible: true,
            componentName: "renderWarnings()",
            model: "",
            type: "dynamic",
            name: "",
            labelAndControlCombined: true
        }
    ]);

    const executionFields = ([
        {
            visible: true,
            componentName: "renderExecutionInfo()",
            model: "",
            type: "dynamic",
            name: "",
            labelAndControlCombined: true
        }
    ]);

    const actionField = ([
        {
            visible: true,
            componentName: "renderActions()",
            model: "",
            type: "dynamic",
            name: "",
            labelAndControlCombined: true
        }
    ])

    let regionSize: RegionSizeRule[] = [
        {
            container: "extrasmall",
            width: "12/12"
        },
        {
            container: "small",
            width: "12/12"
        },
        {
            container: "medium",
            width: "6/12"
        },
        {
            container: "large",
            width: "6/12"
        },
        {
            container: "extralarge",
            width: "6/12"
        }
    ];

    return {
        menuDataSource: [
            // {
            //     type: "save"
            // }
        ],
        additional: {
            objects: []
        },
        tabs: [
            {
                title: "",
                guid: kendo.guid(),
                regions: [
                    {
                        title: "",
                        renderHeader: false,
                        fields: actionField,
                        size: regionSize
                    },
                    {
                        title: Helper.getTranslation("Einsatz.ToBeDeleted"),
                        renderHeader: true,
                        fields: einsatzFields,
                        size: regionSize
                    },
                    {
                        title: Helper.getTranslation("Einsatz.ExecutionAssignmentHeader"),
                        renderHeader: true,
                        fields: executionFields,
                        size: regionSize
                    },
                    {
                        title: Helper.getTranslation("Einsatz.ExecutionAssignment.TargetCapacities"),
                        renderHeader: true,
                        size: regionSize,
                        fields: [
                            {
                                visible: true,
                                componentName: "renderRequirementsGrid()",
                                model: "",
                                type: "dynamic",
                                name: "",
                                labelAndControlCombined: true
                            }
                        ]
                    },
                    {
                        title: Helper.getTranslation("Einsatz.ExecutionAssignment.OtherAssignments"),
                        renderHeader: true,
                        visible: "entity.Preview.TaskExecutionInfo.ExecutionAssignmentsCount > 1",
                        size: [
                            {
                                container: "extrasmall",
                                width: "12/12"
                            },
                            {
                                container: "small",
                                width: "12/12"
                            },
                            {
                                container: "medium",
                                width: "12/12"
                            },
                            {
                                container: "large",
                                width: "12/12"
                            },
                            {
                                container: "extralarge",
                                width: "12/12"
                            }
                        ],
                        fields: ([
                            {
                                visible: true,
                                componentName: "renderAssignmentsGrid()",
                                model: "",
                                type: "dynamic",
                                name: "",
                                labelAndControlCombined: true
                            }
                        ] as any[])
                    }
                ]
            }
        ],
    };

}

class ResourcePlanningDeletingExecutionAssignmentApp extends React.Component<ResourcePlanningDeletingExecutionAssignmentProps, { action: DeleteAction, cancelComment: string }> {
    private common = new AppHelper();
    private assignmentsGridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: false,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "ProjNr",
                title: Helper.getTranslation("WebSMS.Ticket.Assignment.Assignment"),
                width: 60,
                template: "##<a href='" + Config.baseUrl + "ResourcePlanning/Edit?projNr=#=data.ProjNr#&pIndex=#=data.Pindex#' target='_blank'>#=data.ProjNr#/#=data.Pindex#</a>"
            },
            {
                field: "Start",
                title: Helper.getTranslation("WebSMS.FlexTime.Start"),
                width: 100,
                template: "#= kendo.toString(kendo.parseDate(data.Start), 'g')#"
            },
            {
                field: "WorkStart",
                title: Helper.getTranslation("WebSMS.ResourcePlanning.Arbeitsbeginn"),
                width: 100,
                template: "#= kendo.toString(kendo.parseDate(data.WorkStart), 'g')#"
            },
            {
                field: "WorkEnd",
                title: Helper.getTranslation("WebSMS.ResourcePlanning.Arbeitsende"),
                width: 100,
                template: "#= kendo.toString(kendo.parseDate(data.WorkEnd), 'g')#"
            },
            {
                field: "End",
                title: Helper.getTranslation("WebSMS.FlexTime.End"),
                width: 100,
                template: "#= kendo.toString(kendo.parseDate(data.End), 'g')#"
            },
            {
                field: "TotalHours",
                title: Helper.getTranslation("WebCRM.Tasks.ExecuteAll.Capacity"),
                width: 50
            },
            {
                field: "RessNr",
                title: Helper.getTranslation("WebCRM.Tasks.WorkPackage.WorklistRessource"),
                width: 85,
                template: "# if(data.RessNr == null) {# <div><i class='fal fa-user-friends fa-2x' style='margin-right:10px'></i><span>#=data.Group#</span></div> #}else{#<div><i class='fal fa-user fa-2x' style='margin-right:10px'></i><span>#=data.Resource#</span></div>#}#"
            },
            {
                field: "Bemerkung",
                title: Helper.getTranslation("Field.Einsatz.Bemerkung"),
                width: 100
            }
        ]
    };

    private requirementsGridOptions: kendo.ui.GridOptions = {
        sortable: false,
        pageable: false,
        groupable: false,
        filterable: false,
        selectable: false,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "RessNr",
                title: Helper.getTranslation("WebCRM.Tasks.WorkPackage.WorklistRessource"),
                width: 85,
                template: "# if(data.RessNr == null) {# <div><i class='fal fa-user-friends fa-2x' style='margin-right:10px'></i><span>#=data.Group#</span></div> #}else{#<div><i class='fal fa-user fa-2x' style='margin-right:10px'></i><span>#=data.Resource#</span></div>#}#"
            },
            {
                field: "Hours",
                title: Helper.getTranslation("Field.fstasks.CapacityRequirement.Duration"),
                width: 50,
                format: "{0:n2}"
            },
            {
                field: "Count",
                title: Helper.getTranslation("Field.fstasks.CapacityRequirement.CountAssignment"),
                width: 100,
                format: "{0:n2}"
            },
            {
                field: "TotalHours",
                title: Helper.getTranslation("Einsatz.ExecutionAssignment.PlannedTotalHours"),
                width: 100,
                template: "#=kendo.toString(data.Hours * data.Count, 'n2')#",
            },
            {
                field: "TotalAssignmentsCapacity",
                title: Helper.getTranslation("Einsatz.ExecutionAssignment.TotalAssignmentsCapacity"),
                width: 100,
                format: "{0:n2}"
            }
        ]
    };

    constructor(props: ResourcePlanningDeletingExecutionAssignmentProps) {
        super(props);

        this.common.enableHooks = true;
        this.common.init(this);

        if (this.props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(() => {
                this.releaseLock();
            });
        }

        let action =
            props.entity.RecordRight.CanWrite ?
                (props.entity.Preview.TaskExecutionInfo.ExecutionAssignmentsCount == 1 ? DeleteAction.CancelExecution : DeleteAction.RemoveOnly)
                : DeleteAction.Cancel;
        this.state = { action: action, cancelComment: "" };
    }

    private lockId: number;



    releaseLock = () => {
        if (this.lockId != undefined) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.LockId, this.props.entity.LockableTable);
            this.lockId = undefined;
        }
    }

    private handleFieldChange = (field: { model: string }, value: any, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    // noinspection JSUnusedGlobalSymbols
    renderDisplayInfo = () => {
        let assignment = this.props.entity.Preview.ExecutionAssignments.find(ea => ea.ProjNr == this.props.entity.ProjNr && ea.Pindex == this.props.entity.PIndex);

        let rows = 7;

        let arbeitsStart = null;
        if (assignment.Start != assignment.WorkStart) {
            ++rows;
            arbeitsStart = <>
                <div style={{ display: "flex" }}>{Helper.getTranslation("WebSMS.ResourcePlanning.Arbeitsbeginn")}:</div>
                <div style={{ display: "flex" }}>{kendo.toString(kendo.parseDate(assignment.WorkStart), "g")}</div>
            </>;

        }
        let arbeitsEnd = null;
        if (assignment.End != assignment.WorkEnd) {
            ++rows;
            arbeitsEnd = <>
                <div style={{ display: "flex" }}>{Helper.getTranslation("WebSMS.ResourcePlanning.Arbeitsende")}:</div>
                <div style={{ display: "flex" }}>{kendo.toString(kendo.parseDate(assignment.WorkEnd), "g")}</div>
            </>;

        }

        let assignee = assignment.RessNr == null ? `${assignment.Group} (${assignment.GrNr})` : `${assignment.Resource} (${assignment.RessNr})`;

        return (
            <div style={{ display: "grid", gridTemplateColumns: "175px 1fr", gridTemplateRows: `repeat(${rows}, 30px) `, flex: 1, alignItems: "center" }}>
                <div style={{ display: "flex" }}>{Helper.getTranslation("Einsatz.Einsatz")}:</div>
                <div style={{ display: "flex" }}>{assignment.ProjNr} / {assignment.Pindex}</div>

                <div style={{ display: "flex" }}>{Helper.getTranslation("Field.Einsatz.Bemerkung")}:</div>
                <div style={{ display: "flex" }}>{assignment.Bemerkung}</div>

                <div style={{ display: "flex" }}>{Helper.getTranslation("Einsatz.ExecutionAssignment.AssignedTo")}:</div>
                <div style={{ display: "flex" }}>{assignee}</div>

                <div style={{ display: "flex" }}>{Helper.getTranslation("Field.Projekt.startist")}:</div>
                <div style={{ display: "flex" }}>{kendo.toString(kendo.parseDate(assignment.Start), "g")}</div>

                {arbeitsStart}
                {arbeitsEnd}

                <div style={{ display: "flex" }}>{Helper.getTranslation("Field.Projekt.endeist")}:</div>
                <div style={{ display: "flex" }}>{kendo.toString(kendo.parseDate(assignment.End), "g")}</div>

                <div style={{ display: "flex" }}>{Helper.getTranslation("Field.Ressource.arbeitszeit")}:</div>
                <div style={{ display: "flex" }}>{assignment.WorkingHoursPerDay.toFixed(2)}</div>

                <div style={{ display: "flex" }}>{Helper.getTranslation("Statistik.PlanstundenGesamt")}:</div>
                <div style={{ display: "flex" }}>{assignment.TotalHours.toFixed(2)}</div>

            </div>
        );
    }

    private factory = ComponentHelper.createFactory();

    private getDataSource = () => {
        if (this.props.entity.Preview.TaskExecutionInfo.ExecutionAssignmentsCount == 1) {
            return [
                { value: DeleteAction.CancelExecution, text: Helper.getTranslation("Field.Enum.DeleteExecutionAssignmentAction.CancelExecution") },
                { value: DeleteAction.ResetExecution, text: Helper.getTranslation("Field.Enum.DeleteExecutionAssignmentAction.ResetExecution") },
                // {value: DeleteAction.Cancel, text: "Löschen abbrechen"}
            ];
        }

        return [
            { value: DeleteAction.RemoveOnly, text: Helper.getTranslation("Field.Enum.DeleteExecutionAssignmentAction.RemoveOnly") },
            { value: DeleteAction.RemoveAllCancelExecution, text: Helper.getTranslation("Field.Enum.DeleteExecutionAssignmentAction.RemoveAllCancelExecution") },
            { value: DeleteAction.RemoveAllResetExecution, text: Helper.getTranslation("Field.Enum.DeleteExecutionAssignmentAction.RemoveAllResetExecution") },
            // {value: DeleteAction.Cancel, text: "Löschen abbrechen"}
        ]
    }

    // noinspection JSUnusedGlobalSymbols
    renderActions = () => {
        let actionProps = this.factory.getDefaultMultipleRadioButtonsProps();

        let questionDiv = null;
        if (this.props.entity.RecordRight.CanWrite) {
            questionDiv = <div style={{ margin: "10px 0", fontSize: "1.2em" }}>{Helper.getTranslation("Einsatz.DeleteExecutionAssignmentAction")}</div>;
        }

        let readonlyReasonDiv = null;
        if (!this.props.entity.RecordRight.CanWrite) {
            readonlyReasonDiv = (
                <div style={{ margin: "10px 0", fontSize: "1.2em", border: `3px solid`, padding: "8px", borderRadius: "4px", color: "#d50000", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }} >
                    <div>{Helper.getTranslation("Einsatz.NotDeletable")}</div>
                    <div>{this.props.entity.RecordRight.CanWritePermissionDeniedReason}</div>
                </div>
            );
        }

        actionProps.dataSource = this.getDataSource();
        actionProps.field.dataTextField = "text";
        actionProps.field.dataValueField = "value";
        actionProps.disabled = !this.props.entity.RecordRight.CanWrite;
        actionProps.value = this.state.action;
        actionProps.onChange = (_, value: DeleteAction) => {
            this.setState({ action: value });
        }

        const buttonDoIt = (this.props.entity.RecordRight.CanWrite)
            ? (
                <Button
                    iconName="rocket-launch"
                    handleClick={this.proceedWithAction}
                    text={Helper.getTranslation("Standard.Execute")}
                    buttonStyle={{
                        width: "25%",
                        height: "30px",
                        border: "solid 1px #bdbdbd",
                        borderRadius: "var(--border-radius)",
                        margin: "10px 0"
                    }}
                    readOnly={false}
                />)
            : null;

        let commentAllowed = this.state.action == DeleteAction.CancelExecution || this.state.action == DeleteAction.RemoveAllCancelExecution;
        const cancelComment = commentAllowed ?
            (<>
                <div style={{ margin: "10px 3px 0 3px" }}>{Helper.getTranslation("Einsatz.ExecutionAssignment.CancelComment")}:</div>
                <div style={{ margin: "10px 3px 10px 3px" }}>
                    <TextBox field={{ type: "textbox", model: "cancelComment", multiLine: true, textAreaHeight: "100px" }} value={this.state.cancelComment}
                        onChange={this.commantChanged}
                        disabled={false} required={false}
                    />
                </div>

            </>) : null;

        let radioButtons = (this.props.entity.RecordRight.CanWrite) ?
            (<div style={{ margin: "0 0 10px 0" }}>
                <MultipleRadioButtons {...actionProps} />
            </div>) : null;

        return (<div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ margin: "10px 0", fontSize: "1.2em" }}>{Helper.getTranslation("Einsatz.ExecutionAssignmentLinked")}</div>
            {questionDiv}
            {readonlyReasonDiv}
            {radioButtons}
            {cancelComment}
            {buttonDoIt}
        </div>);
    }

    private commantChanged = (_: {}, value: any) => {
        this.setState({ cancelComment: value });
    }

    private proceedWithAction = async () => {
        if (this.state.action != DeleteAction.Cancel) {
            // delete one or more assignments / possibly change execution
            let result = await HTTPService.post<JsonResultClass<DeletedExecutionAssignmentResponse>>(
                `ResourcePlanning/DeleteExecutionAssignment?projNr=${encodeURIComponent(this.props.entity.ProjNr)}&pIndex=${this.props.entity.PIndex}&option=${this.state.action}&comment=${encodeURIComponent(this.state.cancelComment)}`)
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.DeleteSuccessfully"));
                this.props.assignmentDeleted(result.Data.DeletedAssignments.length > 1);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
                return;
            }
        }
        this.common.sheetWrapper.hide();
    }

    // noinspection JSUnusedGlobalSymbols
    renderExecutionInfo = () => {
        const executionInfo = this.props.entity.Preview.TaskExecutionInfo;
        let rows = 5;
        let minDateDiv = null;
        if (Helper.hasValue(executionInfo.MinStartOnDate)) {
            ++rows;
            minDateDiv = <>
                <div style={{ display: "flex" }}>{Helper.getTranslation("Einsatz.ExecutionAssignment.MinStartDate")}:</div>
                <div
                    style={{ display: "flex" }}>{kendo.toString(kendo.parseDate(executionInfo.MinStartOnDate), "d")}</div>
            </>
        }
        let maxDateDiv = null;
        if (Helper.hasValue(executionInfo.MaxEndOnDate)) {
            ++rows;
            maxDateDiv = <>
                <div style={{ display: "flex" }}>{Helper.getTranslation("Einsatz.ExecutionAssignment.MaxEndOnDate")}:</div>
                <div style={{ display: "flex" }}>{kendo.toString(kendo.parseDate(executionInfo.MaxEndOnDate), "d")}</div>
            </>;
        }
        return (
            <div style={{ display: "grid", gridTemplateColumns: "175px 1fr", gridTemplateRows: `repeat(${rows}, 30px) `, flex: 1, alignItems: "center" }}>
                <div style={{ display: "flex" }}>{Helper.getTranslation("WebCRM.Tasks.RecurringTask.IntervalCycle")}:</div>
                <div style={{ display: "flex" }}><a href={`${Config.baseUrl}RecurringTask/Edit?id=${executionInfo.TaskId}`}>{executionInfo.TaskNo}:</a>&nbsp;{executionInfo.Title}</div>
                <div style={{ display: "flex" }}>{Helper.getTranslation("WebCRM.Tasks.Executions.CycleExecution")}:</div>
                <div style={{ display: "flex" }}>#{executionInfo.ExecutionNo}</div>

                <div style={{ display: "flex" }}>{Helper.getTranslation("Einsatz.ExecutionAssignment.CalculatedDue")}:</div>
                <div style={{ display: "flex" }}>{kendo.toString(kendo.parseDate(executionInfo.TriggeredForDate), "d")}</div>

                {minDateDiv}
                {maxDateDiv}

                <div style={{ display: "flex" }}>{Helper.getTranslation("Kapazitaet.Einsaetze")}:</div>
                <div style={{ display: "flex" }}>{executionInfo.ExecutionAssignmentsCount}</div>

                <div style={{ display: "flex" }}>{Helper.getTranslation("Einsatz.ExecutionAssignment.ExecutionState")}:</div>
                <div style={{ display: "flex" }}>{Helper.getTranslation("Field.Enum.ExecutionState." + executionInfo.ExecutionState)}</div>
            </div>
        );
    }

    // noinspection JSUnusedGlobalSymbols
    renderWarnings = () => {
        const mobileFieldServiceWarning = getInMobileFieldServiceWarning(this.props.entity);
        const mobileAppWarning = getInMobileAppWarning(this.props.entity);
        if (!Helper.hasValue(mobileAppWarning) && !Helper.hasValue(mobileFieldServiceWarning))
            return null;

        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {mobileFieldServiceWarning}
                {mobileAppWarning}
            </div>);
    }

    // noinspection JSUnusedGlobalSymbols
    renderAssignmentsGrid = () => {
        const data = this.props.entity.Preview.ExecutionAssignments.filter(ea => ea.ProjNr != this.props.entity.ProjNr || ea.Pindex != this.props.entity.PIndex);

        if (data.length == 0) return null;

        return (
            <div className="flex-container">
                <Grid
                    data={data}
                    options={this.assignmentsGridOptions}
                    id="executionAssignmentsToDeleteGrid"
                />

            </div>
        );
    }

    // noinspection JSUnusedGlobalSymbols
    renderRequirementsGrid = () => {
        const data = this.props.entity.Preview.CapacityRequirements.map(cr => {
            let total = this.props.entity.Preview.ExecutionAssignments
                .filter(ea => ea.CapacityRequirementId == cr.CapacityRequirementId)
                .reduce((sum, ea) => sum + ea.TotalHours, 0);
            return { ...cr, TotalAssignmentsCapacity: total };
        });

        if (data.length == 0) return null;

        return (
            <div className="flex-container">
                <Grid
                    data={data}
                    options={this.requirementsGridOptions}
                    id="deletingAssignmentRequirementsGrid"
                />
            </div>
        );
    }

    componentDidMount() {
        let einsatz = this.props.entity.Preview.ExecutionAssignments.find(e => e.ProjNr == this.props.entity.ProjNr && e.Pindex == this.props.entity.PIndex);
        let baseTitle = Helper.getTranslation("Einsatz.ExecutionAssignmentDeletion.ConfirmationDlgTitle");
        this.common.updateSheetTitle(`${baseTitle} ${this.props.entity.ProjNr} / ${this.props.entity.PIndex} ${einsatz.Bemerkung}`);
        if (Helper.hasValue(this.props.entity.LockId) && this.lockId == undefined && this.props.entity.RecordRight.CanWrite) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.LockId, this.props.entity.LockableTable, 10000);
        }
    }

    render() {
        const props = $.extend({},
            this.props,
            this.common.getHandlersForProps(),
            {
                apphelper: this.common,
                handleFieldChange: this.handleFieldChange,
                title: "Hari Bol!",
                context: {},
            });
        return <CommonApp {...props} />;
    }
}

enum DeleteAction {
    Cancel = 0,
    CancelExecution = 1,
    ResetExecution = 2,
    RemoveOnly = 3,
    RemoveAllCancelExecution = 4,
    RemoveAllResetExecution = 5,
}

interface ResourcePlanningDeletingExecutionAssignmentProps {
    entity: ResourcePlanningDeletingExecutionAssignmentEntity;
    context: {}
    title: string;
    metadata: Metadata
    assignmentDeleted: (multiple: boolean) => void
}

interface ResourcePlanningDeletingExecutionAssignmentEntity extends Entity, DeletingExecutionAssignmentPreviewEntity, ResourcePlanningDeletionEntity {
}

export interface DeletingExecutionAssignmentPreviewEntity extends Entity {
    Preview: DeletingExecutionAssignmentPreview;
    LockId: number;
    LockableTable: string;
}

export interface DeletingExecutionAssignmentPreview {
    TaskExecutionInfo: TaskExecutionInfo;
    CapacityRequirements: CapacityRequirementInfo[];
    ExecutionAssignments: ExecutionAssignmentInfo[];
}

interface DeletedExecutionAssignmentResponse {
    ExecutionCancelled: boolean;
    DeletedAssignments: { ProjNr: string; Pindex: number; Message: string }[]
}

export interface ExecutionAssignmentInfo {
    ExecutionId: string;
    CapacityRequirementId: string;
    ProjNr: string;
    Pindex: number;
    Start: string;
    WorkStart: string;
    WorkEnd: string;
    End: string;
    WorkingHoursPerDay: number;
    Weekend: number;
    GrNr: number;
    Group: string;
    RessNr: string;
    Resource: string;
    TotalHours: number;
    StatusSend: number;
    Datenpaket: string;
    ServiceReportsCount: number;
    Bemerkung: string;
    PlanungIsGuid: string;
}

export interface CapacityRequirementInfo {
    CapacityRequirementId: string;
    GrNr: number;
    Group: string;
    RessNr: string;
    Resource: string;
    Hours: number;
    Count: number;
}

export interface TaskExecutionInfo {
    TaskId: string;
    TaskNo: string;
    Title: string;
    ExecutionNo: number;
    ExecutionId: string;
    ExecutionState: string;
    TriggeredForDate: string;
    MinStartOnDate?: string;
    MaxEndOnDate?: string;
    ExecutionAssignmentsCount: number;
}

interface ResourcePlanningDeletionEntity {
    ProjNr: string;
    PIndex: number;
    Datenpaket: string;
    KNr: number;
    IsSendToMobileApp: boolean;
}

interface ResourcePlanningDeletionDialogProps {
    entity: ResourcePlanningDeletionEntity;
    title: string;
    onOk: () => void;
    onCancel: () => void;
}

const getInMobileFieldServiceWarning = (entity: ResourcePlanningDeletionEntity) => {
    let showWarning = Helper.hasValue(entity.Datenpaket)
        && (Config.settings.deletingAssignmentInMobileClientAction == 1
            || (Config.settings.deletingAssignmentInMobileClientAction == 2
                && Config.settings.excludedKnrsForForbiddenMobileClientAction.includes(entity.KNr)));
    if (showWarning)
        return <div>{Helper.getTranslation("Einsatz.AlreadySendMobFieldService")}</div>;
    else
        return null
}

const getInMobileAppWarning = (entity: ResourcePlanningDeletionEntity) => {
    let showWarning = entity.IsSendToMobileApp
        && (Config.settings.deletingAssignmentInMobileClientAction == 1
            || (Config.settings.deletingAssignmentInMobileClientAction == 2
                && Config.settings.excludedKnrsForForbiddenMobileClientAction.includes(entity.KNr)));
    if (showWarning)
        return <div>{Helper.getTranslation("Einsatz.AlreadySendMobApp")}</div>
    else
        return null
}

class ResourcePlanningDeletionDialog extends React.Component<ResourcePlanningDeletionDialogProps, {}> {
    private _dialogProps: DialogProps = {
        title: this.props.title,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    constructor(props: ResourcePlanningDeletionDialogProps) {
        super(props);

        this.state = {

        };
    }

    render() {
        const mobileFieldServiceWarning = getInMobileFieldServiceWarning(this.props.entity);
        const mobileAppWarning = getInMobileAppWarning(this.props.entity);
        let body = null;
        if (Helper.hasValue(mobileFieldServiceWarning) || Helper.hasValue(mobileAppWarning)) {
            body = <div style={{ display: "flex", flexDirection: "column" }} >
                {mobileFieldServiceWarning}
                {mobileAppWarning}
            </div>;
        }

        return (<>
            <Dialog {...this._dialogProps} open={true}>
                {body}
            </Dialog>
        </>)
    }
}